import './flyer.scss';

import RigAkustikFlyer from '../../components/flyer/RigAkustikFlyer'
import { getLargestImageUrl } from '../../utils/image'
/**
 * @typedef
 */

/**
 * @param {import('react').HTMLProps<HTMLImageElement> & { srcHover?: string}} props
 */
export default function Flyer(props) {
  const { src, flyerAltTextAkustik, flyerAltTextRig, srcHover, showAkustikFlyer = true, showAkustikFlyerFirst = false, akustikFlyerAssets = [], ...imgProps } = props
  const akustikFlyerFront = getLargestImageUrl(akustikFlyerAssets[0])
  const akustikFlyerBack = getLargestImageUrl(akustikFlyerAssets[1]) ?? akustikFlyerFront

  return (
    <div className="container">

      {showAkustikFlyer && showAkustikFlyerFirst && <RigAkustikFlyer className="flyer" flyerAltTextAkustik={flyerAltTextAkustik} src={akustikFlyerFront} srcHover={akustikFlyerBack} />}
      {src &&
        <img
          {...imgProps}
          className="flyer touch"
          src={src}
          alt={flyerAltTextRig + ' - Front'} />}
      {srcHover &&
        <img
          {...imgProps}
          className="flyer touch"
          src={srcHover}
          alt={flyerAltTextRig + ' - Back'} />
      }
      {showAkustikFlyer && !showAkustikFlyerFirst && <RigAkustikFlyer className="flyer" flyerAltTextAkustik={flyerAltTextAkustik} src={akustikFlyerFront} srcHover={akustikFlyerBack} />}
    </div>
  )
}

/**
 * @param {Omit<import('react').HTMLProps<HTMLImageElement>,"src">} props
 */
export function RiGFlyer(props) {
  return (
    <Flyer {...props} />
  )
}
